import { signal } from 'services/SignalsService'

export default class SoundPopupEntity extends PIXI.Container {
  constructor() {
    super()
    signal.once('BUTTON:sound', () => {
      this.parent.removeChild(this)
    })
  }
}
